import { t } from "../../../utils/i18n";
import React, { useState, useEffect } from "react";
import CardSelector from "../CardSelector";

interface Card {
  id: string;
  card_number: string;
  card_type: string;
  status: string;
  first_name: string;
  last_name: string;
}

interface Transaction {
  executed_at: string;
  trn_ref_number: string;
  description: string;
  cr_amount: number;
  dr_amount: number;
  end_bal: number;
}

interface CardActivitiesProps {
  cards: Card[];
  initialCardId: string;
  initialTransactions: Transaction[];
}

const CardActivities: React.FC<CardActivitiesProps> = ({ 
  cards, 
  initialCardId, 
  initialTransactions 
}) => {
  const [selectedCardId, setSelectedCardId] = useState(initialCardId);
  const [transactions, setTransactions] = useState(initialTransactions);
  const [loading, setLoading] = useState(false);

  // Handle card change
  const handleCardChange = (cardId: string) => {
    setSelectedCardId(cardId);
    setLoading(true);
    
    // Redirect to the selected card's activities page
    window.location.href = `/cards/${cardId}/card_activities`;
  };

  return (
    <div className="container-fluid px-2 px-md-4">
      <div className="card shadow-sm rounded-lg">
        <div className="card-header d-flex flex-column justify-content-center align-items-start">
          <h5 className="create-trade-page-title">
            <i className="fa fa-history"></i>{" "}{t("cards.activities.title")}
          </h5>
          <span>{t("cards.activities.subtitle")}</span>
        </div>
        <div className="card-body">
          {/* Card Selector - only shows if user has multiple cards */}
          <CardSelector 
            cards={cards} 
            currentCardId={selectedCardId} 
            onCardChange={handleCardChange} 
          />
          
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">{t("cards.common.loading")}</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>{t("cards.common.date")}</th>
                    <th>{t("cards.activities.reference")}</th>
                    <th>{t("cards.activities.description")}</th>
                    <th>{t("cards.activities.credit")}</th>
                    <th>{t("cards.activities.debit")}</th>
                    <th>{t("cards.common.balance")}</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((transaction, i) => (
                    <tr key={i}>
                      <td>{transaction.executed_at}</td>
                      <td>{transaction.trn_ref_number}</td>
                      <td>{transaction.description}</td>
                      <td>{transaction.cr_amount > 0 ? transaction.cr_amount : "-"}</td>
                      <td>{transaction.dr_amount > 0 ? transaction.dr_amount : "-"}</td>
                      <td>{transaction.end_bal}</td>
                    </tr>
                  ))}
                  {transactions.length === 0 && (
                    <tr>
                      <td colSpan={6} className="text-center">
                        {t("cards.activities.empty")}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardActivities;
